import React, { Component } from "react";
import {Auth} from "aws-amplify";
import TextInput from "../components/TextInput";
import * as prosConnect from "../prodect/ProsConnect";
import {prosNotificationShow} from "../prodect/ProsPopup";
import {isValidPassWord, PROS_PASSWORD_RULES} from "../prodect/ProsCommonUi";
import BasicButton from "../components/BasicButton";

export default class AuthChangePwd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            oldPassword: "",
            newPassword: "",
            confirmNewPassword: "",
            newUser: null
        }
    }

    validateForm() {
        return isValidPassWord(this.state.newPassword) &&
            this.state.newPassword === this.state.confirmNewPassword
    }

    handleKeyDown =(evt)=> {
        if (evt.key === 'Enter'){
            evt.preventDefault()
            this.handleSubmit()
        }
    }

    handleChange = (id, val) => {
        this.setState({
            [id]: val
        })
    }

    handleSubmit = async ()=> {
        this.setState({ isLoading: true });
        try {
            let user = await Auth.currentAuthenticatedUser()
            await Auth.changePassword(user, this.state.oldPassword, this.state.newPassword)
            prosNotificationShow(this, "Salasana vaihdettu")
        } catch (e) {
            prosConnect.prosLogErr('Failed to change pwd exception:', e)
            let errorMsg = e.message || "?"
            prosNotificationShow(this, "Virhe: " +  errorMsg)
        }
        this.setState({ isLoading: false })
    }

    renderWaitConfirmationForm() {
        return <div className={"btn-set_center"}>
                <BasicButton
                    btnClass={"primary"}
                    label={this.state.isLoading ? "Vaihdetaan salasanaa": "Tarkista"}
                    buttonType={"submit"}
                    loading={this.state.isLoading}
                />
        </div>
    }

    renderPasswordFields(){
        return <>
            <TextInput
                id={"oldPassword"}
                label={"Vanha salasana"}
                type={"password"}
                value={this.state.oldPassword}
                onChange={(val)=> this.handleChange('oldPassword', val)}
                placeholder={"Vanha salasana"}
                required
                isValid={isValidPassWord(this.state.oldPassword)}
                onKeyDown={this.handleKeyDown}
            />
            <TextInput
                id={"newPassword"}
                label={"Uusi salasana"}
                type={"password"}
                value={this.state.newPassword}
                onChange={(val)=> this.handleChange('newPassword', val)}
                placeholder={"Uusi salasana"}
                required
                isValid={isValidPassWord(this.state.newPassword)}
                info={PROS_PASSWORD_RULES}
                onKeyDown={this.handleKeyDown}
            />
            {isValidPassWord(this.state.newPassword) ? <TextInput
                    id={"confirmNewPassword"}
                    label={"Vahvista uusi salasana"}
                    type={"password"}
                    value={this.state.confirmNewPassword}
                    onChange={(val)=> this.handleChange('confirmNewPassword', val)}
                    placeholder={"Uusi salasana uudestaan"}
                    required
                    isValid={isValidPassWord(this.state.newPassword) && this.state.newPassword === this.state.confirmNewPassword}
                    onKeyDown={this.handleKeyDown}
                /> : null}
            <div className={"btn-set"}>
                <BasicButton
                    btnClass={"primary"}
                    icon={this.validateForm() ? "check" : null}
                    label={this.state.isLoading ? "Rekisteröidään" : "Vaihda salasana"}
                    disabled={!this.validateForm()}
                    loading={this.state.isLoading}
                    buttonType={"submit"}
                />
            </div>
        </>
    }


    renderForm() {
        return <form onSubmit={(evt)=>{
                evt.preventDefault()
                this.handleSubmit()
            }}>
            {this.renderPasswordFields()}
        </form>
    }

    render() {
        return <>
            <h3>Salasanan vaihto</h3>
            {this.state.newUser === null
                ? this.renderForm()
                : this.renderWaitConfirmationForm()}
        </>
    }
}
